import React from "react";
import { isMobile } from "react-device-detect";
import SecondGenBackground from "../assets/Background.jpg"
import SecondGenBackgroundMobile from "../assets/Background-Portal-Mobile.jpg"

function Background() {
  return <img src={isMobile? SecondGenBackgroundMobile : SecondGenBackground} className={`fixed w-full h-screen top-0 left-0 background primary-background`} alt="Background"/>
}

export default Background;